import script from "./callout.vue?vue&type=script&setup=true&lang=js"
export * from "./callout.vue?vue&type=script&setup=true&lang=js"

import "./callout.vue?vue&type=style&index=0&id=6c6c17a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c6c17a4"]])

export default __exports__